// @ts-ignore
import { H3HexagonLayer } from "@deck.gl/geo-layers";
import { getDeckMapFillColor, hexToRGBA } from "../../helpers";

export const DeckHexagonLayer = ({
    geoJSON,
    selectedGeo,
    selectedTab,
    poiColors,
    cifType,
    isChecked,
    onHover,
    onClick,
    focusedItem,
    isGeoFocused,
    overlayCount,
    catchment,
}: any) => {
    if (!geoJSON || !geoJSON.features?.length) return null;
    // Extract only hexagon features
    const hexagonFeatures = geoJSON.features.filter((feature: any) => {
        const geoValue = feature.properties?.geoValue;
        return geoValue === 'hex';
    });

    if (hexagonFeatures.length === 0) return null;

    // Extract hexagon IDs from the features
    const hexagonData = hexagonFeatures
        .map((feature: any) => {
            const hexGeoId = feature.properties.hexGeoId;
            // Remove prefix if present (e.g., "EPIC-IN-" from "EPIC-IN-8860024901fffff")
            const h3Index = hexGeoId.includes('-') ? hexGeoId.split('-').pop() : hexGeoId;

            return {
                hex: h3Index,
                properties: feature.properties,
                feature: feature
            };
        })
        .filter((hexData: any) => {
            const geoLevel = hexData.properties?.geoLevel;
            if(selectedGeo?.sub_district || catchment || (selectedGeo?.district && isChecked?.catchments)) return true;

            // Filter based on selectedTab
            if (selectedTab === 5) {
                // Tab 5: Show pincode and sub_district hexagons
                return geoLevel === 'pincode' || geoLevel === 'sub_district';
            } else if (selectedTab === 4) {
                // Tab 4: Show only sub_district hexagons (exclude pincode)
                return geoLevel === 'sub_district';
            }
            else{
                return true
            }

            // Default: show all hexagons
          
        });
            console.log("HERE",hexagonData)

    // If no hexagons remain after filtering, return null

    // Create a color map for O(n) lookup instead of O(n²)
    const colorMap = new Map();
    if (poiColors?.colorProperties?.length > 0) {
        for (let colorItem of poiColors.colorProperties) {
            colorMap.set(colorItem.geoId, colorItem.color);
        }
    }

    const getColor = (hexgeoId: any) => {
        const defaultColor = "FFFFFF";
        return colorMap.get(hexgeoId) || defaultColor;
    };

 const getFillColor = (geoLevel: string, geoId: number) => {
        // When no CIF types are selected, show transparent instead of white
        if (cifType.length === 0) return [0, 0, 0, 0];

        const color: [string, number] = getDeckMapFillColor(selectedGeo, selectedTab, geoLevel, getColor(geoId), isChecked?.subregionBoundaries, cifType.length, catchment, 0);
        return hexToRGBA(color[0],(selectedGeo?.sub_district||catchment) && localStorage.getItem("map-style") == "hybrid" ? 100 : color[1]);
    }



    if (hexagonData.length === 0) return null;

    return new H3HexagonLayer({
        id: `hexagon-layer-${geoJSON?.rootProperties?.geoId || "default"}-tab-${selectedTab}`,
        data: hexagonData,
        getHexagon: (d: any) => d.hex,
        // getFillColor: [123, 123, 123, 1], // Fully transparent
 getFillColor: (d: any) => {
            // Handle both old structure (geoId, geoLevel) and new structure (hexGeoId, geoValue)
            const geoId = d.properties.hexGeoId;
            const geoLevel = d.properties.geoValue || d.properties.geoLevel;
            return getFillColor(geoLevel, geoId);
        },
                getLineColor: [0, 0, 0, 255], // Black border
        getLineWidth: 0.15,
        lineWidthUnits: 'pixels',
        filled: true,
        stroked: true,
        extruded: false,
        pickable: true,
        autoHighlight: false, // Disable autohighlight
        highlightColor: [0, 0, 0, 0], // Transparent highlight
        onHover: (info: any) => {
            if (!isGeoFocused && info.object) {
                const { x, y, object } = info;
                if (object && object.properties) {
                    onHover({ ...info, object: { properties: object.properties }, x, y, picked: true });
                } else {
                    onHover({ ...info, x, y, picked: false });
                }
            } else if (!info.object) {
                onHover({ ...info, picked: false });
            }
        },
        onClick: (info: any) => {
            if (info.object && info.object.properties) {
                onClick({ ...info, object: { properties: info.object.properties }, picked: true });
            }
        },
        updateTriggers: {
            getLineColor: [selectedGeo, selectedTab],
            getLineWidth: [selectedGeo, selectedTab, isChecked?.subregionBoundaries, catchment],
        },
    });
};
